import React from 'react'

export default function ReportSummary() {
  return (
    <div className='page-content'>Report Summary page</div>
  )
}
